import { render } from "./LitigationEdit.vue?vue&type=template&id=a29cb65c&scoped=true&ts=true"
import script from "./LitigationEdit.vue?vue&type=script&lang=ts"
export * from "./LitigationEdit.vue?vue&type=script&lang=ts"

import "./LitigationEdit.vue?vue&type=style&index=0&id=a29cb65c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29cb65c"]])

export default __exports__